import React, { useEffect, useState } from 'react';
import { Bell, Check } from 'lucide-react';
import { toast } from 'sonner';
import { getNotificationSettings, updateNotificationSettings } from '../services/api';

export const NotificationSettingsCard = () => {
  const [email, setEmail] = useState('');
  const [enabled, setEnabled] = useState(true);
  const [fallback, setFallback] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getNotificationSettings().then((r) => {
      setEmail(r.data.notification_email || '');
      setEnabled(r.data.notify_devis_signed !== false);
      setFallback(r.data.fallback_email || '');
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await updateNotificationSettings({ notification_email: email, notify_devis_signed: enabled });
      setEmail(r.data.notification_email || '');
      toast.success('Notifications enregistrées');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de l\'enregistrement');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 mb-8" data-testid="notification-settings-card">
      <div className="flex items-center gap-2 mb-1">
        <Bell className="w-5 h-5 text-indigo-600" />
        <h2 className="text-lg font-semibold text-slate-900">Mes notifications</h2>
      </div>
      <p className="text-sm text-slate-500 mb-4">Recevez un e-mail (avec le PDF signé) dès qu'un client signe un devis.</p>
      <div className="flex flex-col md:flex-row md:items-center gap-3">
        <label className="flex items-center gap-2 text-sm text-slate-700 select-none">
          <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} className="h-4 w-4 rounded border-slate-300" data-testid="notif-devis-signed-toggle" />
          Devis signé par un client
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={fallback ? `Par défaut : ${fallback}` : 'adresse@exemple.fr'}
          className="flex-1 h-10 px-3 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          data-testid="notif-email-input"
        />
        <button onClick={save} disabled={saving} className="inline-flex items-center gap-1.5 px-4 h-10 bg-slate-900 text-white rounded-lg text-sm font-medium hover:bg-slate-800 disabled:opacity-50" data-testid="notif-save-btn">
          <Check className="w-4 h-4" /> {saving ? 'Enregistrement…' : 'Enregistrer'}
        </button>
      </div>
    </div>
  );
};

export default NotificationSettingsCard;
